import React from "react";
import "./page-skeleton.scss";

/**
 * Table/list page placeholder — keeps header, filters, and table chrome visible
 * while data loads (matches Base products, Bins, Batches list, etc.).
 */
const PageTableSkeleton = ({
  titleWidth = "220px",
  subtitleWidth = "120px",
  showHeader = true,
  showToolbar = true,
  toolbarFilters = 3,
  columns = 6,
  rows = 8,
  className = "",
}) => (
  <div
    className={`page-skeleton page-table-skeleton ${className}`.trim()}
    aria-busy="true"
    aria-live="polite"
    style={{ "--page-skel-cols": columns }}
  >
    {showHeader && (
      <div className="page-skeleton-header">
        <div>
          <span
            className="page-skel page-skel-title"
            style={{ width: titleWidth, display: "block" }}
          />
          <span
            className="page-skel page-skel-subtitle"
            style={{ width: subtitleWidth, display: "block" }}
          />
        </div>
        <div className="page-skeleton-header-actions">
          <span className="page-skel page-skel-btn" />
          <span className="page-skel page-skel-btn page-skel-btn--primary" />
        </div>
      </div>
    )}

    {showToolbar && (
      <div className="page-skeleton-toolbar">
        <span className="page-skel page-skel-search" />
        {Array.from({ length: toolbarFilters }).map((_, i) => (
          <span className="page-skel page-skel-filter" key={`filter-${i}`} />
        ))}
      </div>
    )}

    <div className="page-skeleton-table-card">
      <div className="page-skeleton-table-head">
        {Array.from({ length: columns }).map((_, i) => (
          <span className="page-skel page-skel-th" key={`th-${i}`} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, ri) => (
        <div className="page-skeleton-table-row" key={`row-${ri}`}>
          {Array.from({ length: columns }).map((_, ci) => (
            <span
              className={`page-skel page-skel-td${
                ci === 0 ? " page-skel-td--wide" : ci === columns - 1 ? " page-skel-td--narrow" : ""
              }`}
              key={`td-${ri}-${ci}`}
            />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default PageTableSkeleton;
